import { render, staticRenderFns } from "./CardMessageRecord.vue?vue&type=template&id=3553b3ce&scoped=true"
import script from "./CardMessageRecord.vue?vue&type=script&lang=js"
export * from "./CardMessageRecord.vue?vue&type=script&lang=js"
import style0 from "./CardMessageRecord.vue?vue&type=style&index=0&id=3553b3ce&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3553b3ce",
  null
  
)

export default component.exports